import styled, { css } from 'styled-components';
import { theme } from '../../theme';
import { BodyText } from '../typography';
import { ProgressSize } from './Progress';

const ProgressHeaderStylesSmall = css`
  padding: ${theme.spacings[1].rem} 0;
`;

const ProgressHeaderStylesLarge = css`
  padding: 0;
`;

const headerSizeStyles = {
  small: ProgressHeaderStylesSmall,
  large: ProgressHeaderStylesLarge,
};

type ProgressHeaderProps = { size: ProgressSize };
export const ProgressHeader = styled.header<ProgressHeaderProps>`
  display: flex;
  flex-direction: column;
  margin: 0;

  ${({ size }) => headerSizeStyles[size]};
`;

export const SubHeading = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-top: ${theme.spacings[2].rem};
`;

const SubHeadingPrimaryStylesSmall = css`
  margin-right: ${theme.spacings[5].rem};
`;

const SubHeadingPrimaryStylesLarge = css`
  margin-right: auto;
`;

const subHeadingPrimarySizeStyles = {
  small: SubHeadingPrimaryStylesSmall,
  large: SubHeadingPrimaryStylesLarge,
};

type SubHeadingProps = {
  progressSize: ProgressSize;
};
export const SubHeadingPrimary = styled(BodyText)<SubHeadingProps>`
  ${({ progressSize }) => subHeadingPrimarySizeStyles[progressSize]};

  strong {
    color: ${theme.colors.primary.graysGray};
  }
`;

const SubHeadingSecondaryStylesSmall = css`
  margin-left: ${theme.spacings[1].rem};
`;

const SubHeadingSecondaryStylesLarge = css`
  margin-left: ${theme.spacings[2].rem};
`;

const subHeadingSecondarySizeStyles = {
  small: SubHeadingSecondaryStylesSmall,
  large: SubHeadingSecondaryStylesLarge,
};

export const SubHeadingSecondary = styled.div<SubHeadingProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * + * {
    ${({ progressSize }) => subHeadingSecondarySizeStyles[progressSize]};
  }
`;
